<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-05-15 10:11:32
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 14:35:36
-->
<template>
  <a-modal
    :title="`提醒配置（${organizationNameTwo}）`"
    :visible="visibleTwo"
    centered
    @cancel="handleCancel"
    width="1000px"
  >
    <template slot="footer">
      <a-button    @click="handleCancel">取消</a-button>
      <a-button :loading="confirmLoading" v-if="codeData.indexOf('318') != -1" type="primary"  @click="handleOk">确定</a-button>
      <a-button  v-if="codeData.indexOf('318') == -1" style="" disabled >确定</a-button>
    </template>
    <div class="colum-title-box">
      <i  class="el-icon-info"></i
      >本级组织收到申请后，将向以下管理员发送提醒短信
    </div>
    <div class="set-box">
      <div class="left">
        <a-input-search
          style="width: 100%; margin-top: 14px;margin-bottom:20px"
          placeholder="搜索管理员姓名或手机号"
          @search="onSearch"
          v-model="value"
        />
       <div class="box-table">
           <coententTable
                :loading="loading"
                :y="height"
                :columns="columns"
                :dataSource="dataSource"
                :isSelectRow="isSelectRow"
                :rowKeys="rowKeys"
                @selectedRowKeys="selectedRowKeys"
                ></coententTable>
       </div>
        <div class="box-page">
             <a-pagination
            :current="pagination.current"
            :pageSize="pagination.pageSize"
            :total="pagination.total"
            size="small"
            @change="onShowSizeChange"
            @showSizeChange="handleSizeChange"
            :page-size-options="pagination.pageSizeOptions"
          />
        </div>
      </div>
     
        <div class="right">
            <div class="right-title">
                <div class="num-box">已选 {{rowKeys.length}} 名人员</div>
                <div @click="qingkong" class="btn-box">清空</div>
            </div>
             <a-spin :spinning="loadingTwo">
              <div class="right-one" v-for="(item,index) in selectData">
                    <div class="name-box">{{item.name}} {{item.phone}} {{item.organizationName}}</div><i @click="deleteOne(item,index)" class="ri-close-fill icon-txt"></i>
              </div>
             </a-spin>
        </div>
     
    </div>
  </a-modal>
</template>
<script>
import { applyOpenOrganList,findSmsManagementList,saveManagement } from "../index";
import coententTable from "@/components/coentent_table.vue";
export default {
  data() {
    return {
      visibleTwo: false,
      loading: false,
      confirmLoading:false,
      loadingTwo:false,
      height: 260,
      columns: [
        {
          title: "管理员姓名",
          dataIndex: "name",
          ellipsis: true,
          width: 120,
        },
        {
          title: "登录手机号",
          dataIndex: "phone",
          width: 120,
          ellipsis: true,
        },
        {
          title: "所属组织",
          dataIndex: "organizationName",
          width: 120,
          ellipsis: true,
        },
      ],
       pagination: {
        current:1,
        pageSize:15,
        total:0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      isSelectRow:true,
      rowKeys:[],
      selectData:[],
      oldSelectData:[],
      value:'',
      codeData:[],
    };
  },
  props: ["configShow","organizationNameTwo","organization"],
  components:{
    coententTable,
  },
  mounted() {
    this.visibleTwo = this.configShow;
    this.getList();
    this.getManageList();
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
     
  },
  methods: {
    getManageList(){
        this.loadingTwo = true;
        findSmsManagementList({
          id:this.organization,
        }).then((res)=>{
            if(res.code == 0){
                this.oldSelectData = res.data;
                this.selectData = res.data;
                let array = [];
                for (let index = 0; index < this.oldSelectData.length; index++) {
                  const element = this.oldSelectData[index];
                  array.push(element.id)
                }
                this.rowKeys = array;
                this.loadingTwo = false;
            }
        })
    },
    qingkong(){
        this.selectData = [];
        this.rowKeys = [];
    },
    deleteOne(item,indexTwo){
        for (let index = 0; index < this.rowKeys.length; index++) {
            const element = this.rowKeys[index];
            if(element == item.id){
                this.rowKeys.splice(index,1)
            }
        }
        this.selectData.splice(indexTwo,1)
    },
    getList() {
      this.loading = true;
      applyOpenOrganList({
        childrenType: 2,
        current:this.pagination.current,
        size:this.pagination.pageSize,
        organs: '',
        type:3,
        value:this.value,
      }).then((res) => {
         if(res.code == 0){
            this.dataSource = res.data.records;
            this.pagination.current =  res.data.current;
            this.pagination.total =  res.data.total;
         }
         this.loading = false;
      });
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getList();
    },
     selectedRowKeys(keys,selectedRows) {
      this.rowKeys = keys;
      if(this.rowKeys.length != selectedRows.length){
         let arrayTwo = JSON.parse(JSON.stringify(this.selectData))
          for (let index = 0; index < this.rowKeys.length; index++) {
            const element = this.rowKeys[index];
            for (let indexTwo = 0; indexTwo < this.dataSource.length; indexTwo++) {
              const elementTwo = this.dataSource[indexTwo];
              if(element == elementTwo.id){
                  arrayTwo.push(elementTwo);
              }
            }
            for (let indexThree = 0; indexThree < this.oldSelectData.length; indexThree++) {
              const elementThree = this.oldSelectData[indexThree];
              if(element == elementThree.id){
                 arrayTwo.push(elementThree);
              }
            }
          }
         let arrayData = this.queOne(arrayTwo);  
         this.selectData = arrayData;
         for (let index = 0; index < this.selectData.length; index++) {
          const element = this.selectData[index];
          if(this.rowKeys.indexOf(element.id) == -1){
              this.selectData.splice(index,1)
          }
         }
          
      }else{
        this.selectData = selectedRows;
      }
    },
    queOne(arr){
      let obj = {};
          arr = arr.reduce((newArr, next) => {
            obj[next.id] ? "" : (obj[next.id] = true && newArr.push(next));
            return newArr;
          }, []);
          return arr;
    },
    handleOk() {
        this.confirmLoading = true;
        saveManagement({
          ids:this.rowKeys,
          mbsOrganizationId:this.organization,
        }).then((res)=>{
            if(res.code == 0){
                this.$emit('handleOk')
                this.visibleTwo = false;
            }
            this.confirmLoading = false;
        })
        
    },
    handleCancel() {
      this.visibleTwo = false;
      this.$emit("handleCancel");
    },
    onSearch() {
       this.pagination.current = 1;
       this.getList();
    },
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.current = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-modal-title {
  color: rgba(48, 49, 51, 1) !important;
  font-size: 18px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
  border-bottom: none;
}
/deep/ .ant-modal-close {
  color: rgba(48, 49, 51, 1);
  font-weight: 600;
}
/deep/ .ant-modal-footer {
  border-top: none;
  padding-bottom: 24px;
  padding-right: 24px;
}
/deep/ .ant-modal-header {
  border-bottom: none;
  padding: 24px;
  padding-bottom: 20px;
}
/deep/ .ant-modal-body {
  padding-top: 0px;
}
/deep/ .ant-input {
  height: 36px;
  text-indent: 24px;
}
/deep/ .ant-input-affix-wrapper .ant-input-suffix {
  left: 10px;
  background: #fff;
  width: 20px;
}
/deep/ .ant-input-search-icon {
  font-size: 18px;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
}
.set-box {
  height: 440px;
  line-height: 20px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(228, 231, 237, 1);
  display: flex;
  margin-top: 20px;
  padding-left: 14px;
  padding-right: 14px;
  .left {
    flex: 1;
    padding-right: 14px;
    position: relative;
    padding-bottom: 14px;
    /deep/ .ant-pagination{
            position: absolute;
            bottom: 12px;
            width: 100%;
    }
  }
  .el-icon-info{
    margin-right: 8px;
  }
  .right {
    width: 440px;
    border-left: solid 1px rgba(228, 231, 237, 1);
    padding: 14px;
    padding-right: 0px;
    /deep/ .ant-spin-nested-loading{
      max-height: 385px;
      overflow-y: auto;
    }
    .right-title{
        display: flex;
        justify-content: space-between;
        .num-box{
            height: 36px;
            color: rgba(48, 49, 51, 1);
            font-size: 14px;
            font-family: HarmonyOS_Sans_SC-regular;
            display: flex;
            align-items: center;
        }
        .btn-box{
            height: 36px;
            color: rgba(23, 109, 230, 1);
            font-size: 14px;
            font-family: Roboto-regular;
            display: flex;
            align-items: center;
            padding-right: 14px;
            cursor: pointer;
        }
    }
    .right-one{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 36px;
        align-items: center;
        background-color: rgba(255, 255, 255, 1);
        .icon-txt{
            font-size: 18px;
            color: rgba(48, 49, 51, 1);
            font-weight: 600;
            cursor: pointer;
        }
        .name-box{
            width: 300px;
            overflow:hidden;
            white-space: nowrap;
            text-align:left;
            text-overflow: ellipsis;
            -o-text-overflow:ellipsis;
        }
    }
  }
}
.tree-box {
  text-align: left;
  height: 370px;
  overflow-y: auto;
  /deep/ .ant-tree li .ant-tree-node-content-wrapper {
    height: auto !important;
  }
}
/deep/ .table{
    margin: 0px;
    margin-top: 14px;

}
/deep/ .ant-btn{
  width: 68px;
  height: 36px;
  line-height: 20px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
}
/deep/ .ant-btn-primary{
  width: 68px;
  height: 36px;
  line-height: 20px;
  border-radius: 4px;
  background-color: rgba(23, 109, 230, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
}
/deep/ .ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline):not(.ant-btn-icon-only){
  padding-left:16px !important;
}

@media screen and (max-width: 720px) {
  .set-box{
    display: block;
    height: 64vh;
  }
  /deep/ .ant-table-body-inner{
    max-height: 15vh !important;
  }
  /deep/ .ant-table-body{
      max-height: 16vh !important;
     
  }
  /deep/ .ant-modal-body{
     font-size: 10px !important;
  }
  .set-box .left .ant-pagination{
    bottom: -28px !important;
  }
  .el-icon-info{
    margin-right: 2px;
  }
  .colum-title-box{
    padding-left: 5px;
  }
  .set-box .right{
    border-left: none;
    padding-top: 30px;
    padding-left: 0px;
    width: auto;
    /deep/ .ant-spin-nested-loading{
           max-height: 17vh !important;
    } 
  }
  .set-box .left{
    padding-right: 0px;
  }
  /deep/ .el-empty__image{
    width: 46px !important;
  }
   /deep/ .ant-select-enabled{
                width: 30% !important;
            }
}
</style>